import { ExpandCircleDownRounded } from "@mui/icons-material"
import React, { FC, ReactNode, useState } from "react"

import { IconButton } from "../iconButton"

import { create } from "src/helpers/bem"

import styles from "./CollapseableSection.module.scss"

const bem = create(styles, "CollapseableSection")

interface CollapseableSectionProps {
  children?: ReactNode
}

export const CollapseableSection: FC<CollapseableSectionProps> = ({
  children,
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(false)

  return (
    <div className={bem("", collapsed ? "collapsed" : "")}>
      <IconButton
        className={bem("iconButton")}
        icon={ExpandCircleDownRounded}
        onClick={() => setCollapsed(!collapsed)}
      />
      <section className={bem("section")}>{children}</section>
    </div>
  )
}
